import Vue from 'vue'
import Vuex from 'vuex'
import auth from "@/store/auth";
import menu from "@/store/menu";
import search from "@/store/search";
import notifications from "@/store/notifications";

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        auth: auth,
        menu: menu,
        search: search,
        notifications: notifications,
    }
})
